import { getFormDataFromObject } from '@cvt/helpers/form';
import { camelizeObject, snakizeObject } from '@cvt/helpers/object';

export const mapGiftData = (data: Gift.GiftApi): Gift.Gift => {
  return camelizeObject<Gift.Gift>(data);
};

export const mapGiftCrudData = (data: Gift.Crud): FormData => {
  const apiData: Gift.CrudApi = snakizeObject(data);
  
  const formData = getFormDataFromObject(apiData);
  
  return formData;
};